module.exports = __webpack_public_path__ + "img/105-cameroon.d91f2e84.svg";